// require('smoothscroll-polyfill').polyfill();
import 'babel-polyfill'
// import './utils/polyfills'

import moment from 'moment';
//moment.locale('fi');

import React from 'react';
import { render } from 'react-dom';

import configureStore from './configureStore';
import Root from './modules/Root';
import 'current-input';
import 'normalize.css';
import './index.css';

const store = configureStore();

const select = (state) => state.localize.locale;

const observeStore = (store, select, onChange) => {
  let currentState;

  const handleChange = () => {
    let nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  const unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}

observeStore(store, select, function(state){
  moment.locale(state);
  try {
    localStorage.setItem('locale', state);
  } catch(e) {}
});

render(
  <Root store={store} />,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./modules/Root', () => {
    render(
      <Root store={store} />,
      document.getElementById('root')
    );
  })
}



// WEBPACK FOOTER //
// ./src/index.js